<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.company')">
              <j-search-select-tag
                type="list"
                v-model="queryParam.paCompanyCode"
                :triggerChange="true"
                @change="changeCompanyCode"
                :dictOptions="companyDictOptions"
                :placeholder="$t('label.pleaseSelectCompany')"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.department')">
              <a-select
                :placeholder="$t('label.pleaseSelectServiceDepartment')"
                showSearch
                option-filter-prop="children"
                v-model="queryParam.paDeptCode"
              >
                <a-select-option
                  v-for="item in paDeptCodeList"
                  :key="item.orgCode"
                  :label="item.orgCode"
                  :value="item.orgCode"
                >
                  {{ item.departName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.grower')">
              <j-search-select-tag
                type="list"
                v-model="queryParam.pbFarmerCode"
                :trigger-change="true"
                :dict="dictPbFarmerCode"
                :placeholder="$t('label.pleaseSelectGrower')"
              />
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('label.contractCode')">
                <j-input :placeholder="$t('label.pleaseEnterTheContractCode')" v-model="queryParam.code"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('label.status')">
                <j-dict-select-tag :placeholder="$t('label.pleaseSelectStatus')" v-model="queryParam.approvalStatus" dictCode="shzt" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('button.search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('button.reset')
              }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button v-has="'addContract'" @click="handleAdd" type="primary" icon="plus">{{ $t('button.add') }}</a-button>
      <!--      <a-button type="primary" icon="download" @click="handleExportXls('合同')">{{$t('button.export')}}</a-button>-->
      <!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
      <!--        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
      <!--      </a-upload>-->
      <!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
      <!--        <a-menu slot="overlay">-->
      <!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
      <!--        </a-menu>-->
      <!--        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
      <!--      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{ x: true }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-has="'editContract'" v-if="record.approvalStatus == '00'" @click="handleEdit(record)">{{
            $t('button.edit')
          }}</a>
          <a-divider v-if="record.approvalStatus == '00'" type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('button.more') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('button.details') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定复制?" @confirm="() => handleCopeContact(record.id)">
                  <a>{{$t('button.copy')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.lockStatus == 'Y' && record.approvalStatus == '30'">
                <a-popconfirm title="确定生成结算单?" @confirm="() => handleSettle(record.id)">
                  <a>结算</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'approvalContract'" v-if="record.approvalStatus == '00'">
                <a-popconfirm :title="$t('tip.makeSureTheReviewIsApproved')" @confirm="() => handlePass(record.id)">
                  <a>{{$t('button.reviewApproved')}}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item
                v-if="(record.breedBatchCode == '' || record.breedBatchCode == null) && record.approvalStatus == '30'"
              >
                <a-popconfirm :title="$t('tip.confirmToVoid')" @confirm="() => handleVoid(record.id)">
                  <a>{{ $t('button.voided') }}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-has="'approvalContract'" v-if="record.approvalStatus == '00'">
                <a-popconfirm :title="$t('tip.rejected')" @confirm="() => handleFailure(record.id)">
                  <a>{{$t('button.rejected')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <!--              <a-menu-item>-->
              <!--                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">-->
              <!--                  <a>{{$t('button.delete')}}</a>-->
              <!--                </a-popconfirm>-->
              <!--              </a-menu-item>-->
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <efs-md-contract-modal ref="modalForm" @ok="modalFormOk" />
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import EfsMdContractModal from './modules/EfsMdContractModal'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import '@/assets/less/TableExpand.less'
import { putAction, getAction } from '@api/manage'
import JInput from '@/components/jeecg/JInput'

export default {
  name: 'EfsMdContractList',
  mixins: [JeecgListMixin],
  components: {
    EfsMdContractModal,
    JInput,
  },
  data() {
    return {
      mainTable: 'efs_md_contract',
      description: '合同管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          //title: '合同编码',
          slotName: 'tableHeader.contractCode',
          align: 'center',
          dataIndex: 'code',
          scopedSlots: { title: 'tableHeader.contractCode'}
        },
        {
          //title: '合同名称',
          slotName: 'tableHeader.contracName',
          align: 'center',
          dataIndex: 'name',
          scopedSlots: { title: 'tableHeader.contracName' },
        },
        {
          //title: '服务部',
          slotName: 'tableHeader.department',
          align: 'center',
          dataIndex: 'paDeptCode_dictText',
          scopedSlots: { title: 'tableHeader.department'}
        },
        {
          //title: '养户',
          slotName: 'tableHeader.grower',
          align: 'center',
          dataIndex: 'pbFarmerCode_dictText',
          scopedSlots: { title: 'tableHeader.grower'}
        },

        {
          //title: '合作模式',
          slotName: 'tableHeader.cooperationMode',
          align: 'center',
          dataIndex: 'cooperMode_dictText',
          scopedSlots: { title: 'tableHeader.cooperationMode'}
        },
        /*{
          //title: '饲养批次',
          slotName: 'tableHeader.feedingLot',
          align: 'center',
          dataIndex: 'breedBatchCode',
          scopedSlots: { title: 'tableHeader.feedingLot'}
        },*/
        {
          //title: '签订日期',
          slotName: 'tableHeader.dateOfSigning',
          align: 'center',
          dataIndex: 'partyBSignDate',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
          scopedSlots: { title: 'tableHeader.dateOfSigning'}
        },
        {
          //title: '生效日期',
          slotName: 'tableHeader.effectiveDate',
          align: 'center',
          dataIndex: 'conStartDate',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
          scopedSlots: { title: 'tableHeader.effectiveDate'}
        },
        {
          //title: '公司',
          slotName: 'tableHeader.company',
          align: 'center',
          dataIndex: 'paCompanyCode_dictText',
          scopedSlots: { title: 'tableHeader.company'}
        },

        {
          //title: '审核状态',
          slotName: 'tableHeader.auditStatus',
          align: 'center',
          dataIndex: 'approvalStatus_dictText',
          scopedSlots: { title: 'tableHeader.auditStatus'}
        },
        {
          //title: '操作',
          slotName: 'tableHeader.operation',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
        },
      ],
      url: {
        list: '/newContractManage/efsMdContract/list',
        delete: '/newContractManage/efsMdContract/delete',
        deleteBatch: '/newContractManage/efsMdContract/deleteBatch',
        exportXlsUrl: '/newContractManage/efsMdContract/exportXls',
        importExcelUrl: 'newContractManage/efsMdContract/importExcel',
        companyUrl: '/sys/sysDepart/getDepartListByPermission',
        serviceDepartment: '/sys/sysDepart/getServiceDepartment',
      },
      dictOptions: {},
      companyDictOptions: [],
      dictPbFarmerCode: '',
      paDeptCodeList: [],
    }
  },
  created() {
    this.getCompanyDictOptions()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    handleSettle(id) {
      putAction('/newContractManage/efsMdContract/updateSettleStatus', { id: id, approvalStatus: '60' }).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleFailure(id) {
      putAction('/newContractManage/efsMdContract/updateApprovalStatus', { id: id, approvalStatus: '40' }).then(
        (res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.error(res.message)
          }
        }
      )
    },
    handleCopeContact(id) {
      putAction('/newContractManage/efsMdContract/copeEfsMdContract', { id: id, approvalStatus: '00' }).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handlePass(id) {
      putAction('/newContractManage/efsMdContract/updateApprovalStatus', { id: id, approvalStatus: '30' }).then(
        (res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.error(res.message)
          }
        }
      )
    },
    handleVoid(id) {
      putAction('/newContractManage/efsMdContract/updateApprovalStatus', { id: id, approvalStatus: '70' }).then(
        (res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.error(res.message)
          }
        }
      )
    },
    // 获取公司列表
    getCompanyDictOptions() {
      let that = this
      getAction(that.url.companyUrl, { orgCategory: '1' }).then((res) => {
        console.log(res)
        if (res.success) {
          that.companyDictOptions = res.result
        }
      })
    },
    changeCompanyCode(companyCode) {
      getAction(this.url.serviceDepartment, { companyCode: companyCode }).then((res) => {
        if (res.success) {
          this.paDeptCodeList = res.result
        }
      })
      this.dictPbFarmerCode =
        "efs_md_farmer,CONCAT(code((comma))((verticalLine))((comma))name),code,company_code like '" +
        companyCode +
        "*' and del_flag='N'"
    },

  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>